export default __webpack_public_path__ + "static/11.04-58f94cdea27eb60f520d7bf77bbb685a.png";